<template>
    <p class="mt-1 text-xs text-gray-500">
        <slot/>
    </p>
</template>

<script>
export default {
    name: 'FormHelp',
};
</script>
